'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ASC = exports.ASC = 'Ascending';
var COLLECTION_TYPE = exports.COLLECTION_TYPE = 'CollectionList';
var CONFIRMED = exports.CONFIRMED = 'Confirmed';
var CREATED = exports.CREATED = 'Created';
var DESC = exports.DESC = 'Descending';
var ENDED = exports.ENDED = 'Ended';
var LIST_ITEM = exports.LIST_ITEM = 'ListItem';
var FAV_TITLE = exports.FAV_TITLE = 'Favorites';
var PREDICATE = exports.PREDICATE = 'itemListElement';